import React, { useEffect, useState } from "react";
import { Form, Media } from "react-bootstrap";
import Layout from "../../components/Layout";
import { Link } from "react-router-dom";
import { callAPI } from "../../helper/apiUtils";
import { $crud } from "../../helper/CrudFactory";
import { BASE_URL } from "../../helper/constants";
import { DE } from "../../Languages/DE";
import { EN } from "../../Languages/EN";
import LanguageContext from "../../helper/LanguageContext";
import { Scrollbars } from "react-custom-scrollbars";
import _ from "lodash";
import { convertBranchRole } from "../../helper/convertor";
import { useSelector } from "react-redux";
import "./Followings.css";
const renderThumb = ({ style, ...props }) => {
  const thumbStyle = {
    borderRadius: 6,
    backgroundColor: "rgba(var(--kjuup-accent-rgb), 0.8)",
  };
  return (
    <div
      className="thumb-style"
      style={{ ...style, ...thumbStyle }}
      {...props}
    />
  );
};
const CustomScrollbars = (props) => (
  <Scrollbars
    renderThumbHorizontal={renderThumb}
    renderThumbVertical={renderThumb}
    {...props}
  />
);
function Followings(props) {
  const { isGerm, strings } = React.useContext(LanguageContext);
  const [followings, setFollowings] = useState([]);
  const [allFollowing, setAllFollowing] = useState([])
  const [search, setSearch] = useState("")
  const [isLoading, setIsLoading] = useState(true);
  const [isContentReady, setIsContentReady] = useState(false);
  const [showSkeleton, setShowSkeleton] = useState(true);
  const getFollowings = async () => {
    setIsLoading(true);
    setIsContentReady(false);
    setShowSkeleton(true);
    try {
      const { data } = await callAPI(`/user/following`, {}, "GET");
      const followingsList = _.sortBy(data.followings || [], [
        (follower) =>
          follower?.lastName?.toLowerCase() || follower?.fullName?.toLowerCase(),
      ]);
      setAllFollowing([...followingsList])
      setFollowings(followingsList);
    } catch (error) {
      console.error('Error loading followings:', error);
      setFollowings([]);
      setAllFollowing([]);
    } finally {
      setIsLoading(false);
      setTimeout(() => {
        setShowSkeleton(false);
      }, 300);
      setTimeout(() => {
        setIsContentReady(true);
      }, 400);
    }
  };
  useEffect(() => {
    getFollowings();
  }, []);

  const removeFollowings = async (following) => {
    const message = (strings.remove_following_confirm || "Do you really want to remove {name}?").replace("{name}", following.fullName || "");
    await $crud.confirm({
      title: "",
      textContent: message,
      options: {
        ok: strings.confirm,
        cancel: strings.cancel,
      },
    });
    const { data } = await callAPI(`/user/${following.id}/follow`, {}, "GET");
    $crud.notify({
      type: data.status ? "success" : "error",
      message: data.message,
    });
    await getFollowings();
  };
  const removeCompanyFollowings = async (following) => {
    const message = (strings.remove_following_confirm || "Do you really want to remove {name}?").replace("{name}", following.fullName || "");
    await $crud.confirm({
      title: "",
      textContent: message,
      options: {
        ok: strings.confirm,
        cancel: strings.cancel,
      },
    });
    const { data } = await callAPI(
      `/company/${following.id}/follow`,
      {},
      "GET"
    );
    $crud.notify({
      type: data.status ? "success" : "error",
      message: data.message,
    });
    await getFollowings();
  };
  const searchFollowing = async (value) => {
    setSearch(value);
    value = value.trim();
    const searchResult = await allFollowing.filter((itm) => {
      if (!itm.isCompany && (itm.firstName?.toLowerCase().startsWith(value?.toLowerCase()) || itm.lastName?.toLowerCase().startsWith(value?.toLowerCase()) || itm.fullName?.toLowerCase().startsWith(value?.toLowerCase()))) {
        return true
      }
    });
    if (value === "") {
      setFollowings(allFollowing);
    } else {
      setFollowings(searchResult);
    }
  };

  const isDesktopResolution = useSelector(state => state.isDesktopResolution)

  return (
    <React.Fragment>
      {isLoading || showSkeleton ? (
        <div className={`following follower loading followings followings--skeleton${showSkeleton ? ' followings--skeleton-active' : ''} ${!showSkeleton ? 'skeleton-fade-out' : ''}`}>
          {/* Skeleton Header */}
          <div className="main_heading followings__heading">
            <div className="skeleton skeleton-icon followings__sk-icon"></div>
            <div className="skeleton skeleton-text followings__sk-title"></div>
          </div>
          {/* Skeleton Search */}
          <div className="search followings__search">
            <div className="skeleton followings__sk-search"></div>
          </div>
          {/* Skeleton List Items */}
          <div className="my-scroll contact_height followings__scroll">
            {[1, 2, 3, 4, 5].map((item) => (
              <div key={item} className="post_notification followings__sk-item">
                <div className="my_post followings__sk-row">
                  <div className="skeleton skeleton-image followings__sk-avatar"></div>
                  <div className="kj-flex-1">
                    <div className="skeleton skeleton-text followings__sk-line"></div>
                    <div className="skeleton skeleton-text short followings__sk-line-short"></div>
                  </div>
                  <div className="skeleton followings__sk-button"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className={`following follower loaded followings followings--content ${isContentReady ? 'company-content-fade-in' : ''}`}>
          <div className="main_heading followings__heading followings__heading--content">
            <Link to="/profile">
              <span className="material-symbols-outlined material-arrow-left">
                keyboard_arrow_left
              </span>
            </Link>
            {strings.followings}
          </div>
          <div className="search followings__search">
            <Form.Group controlId="exampleForm.ControlInput1">
              <Form.Control
                autocomplete="off"
                onChange={(e) => searchFollowing(e.target.value)}
                value={search}
                type="search"
                placeholder={strings.search}
              />
            </Form.Group>
          </div>
          <div className="my-scroll contact_height followings__scroll">
            <CustomScrollbars
              autoHide
              autoHideTimeout={500}
              autoHideDuration={200}
              className="bottom-bar"
            >
              {followings && followings.length > 0 ? (
                _.sortBy(
                  followings,
                  [(us) => us?.lastName?.toLowerCase()],
                  ["lastName"]
                ).map((following, index) => (
                  <div key={following.id} className="post_notification followings__item" style={{ '--followings-item-delay': `${index * 0.05}s` }}>
                    <div className="my_post">
                      <Media>
                        <img
                          width={30}
                          height={30}
                          className={`mr-3 followings__avatar${following.isCompany ? (following.avatar ? ' followings__avatar--company' : ' followings__avatar--company-placeholder') : ''}`}
                          src={
                            following.avatar
                              ? BASE_URL + following.avatar
                              : following.isCompany ? process.env.PUBLIC_URL + "/assets/img/Companies-No-Image.svg" : process.env.PUBLIC_URL + "/assets/img/head.svg"
                          }
                          alt="Generic placeholder"
                          onError={(e) => {
                            e.target.src = following.isCompany 
                              ? process.env.PUBLIC_URL + "/assets/img/Companies-No-Image.svg" 
                              : process.env.PUBLIC_URL + "/assets/img/head.svg";
                          }}
                        />
                        <Media.Body>
                          <div className="authore_name">
                            <Link to={following.isCompany ? `/foreign-company-details/${following.id}` : `/user-profile/${following.id}`}>
                              <h5>{following.fullName}</h5>
                            </Link>
                            <p className="followings__role">{convertBranchRole(following.buildingIndustryRole, isGerm)}</p>
                          </div>
                        </Media.Body>
                        <button
                          type="button"
                          className="kj-btn kj-btn--outline kj-btn--on-surface kj-btn--sm"
                          onClick={(e) => {
                            e.preventDefault();
                            following.isCompany
                              ? removeCompanyFollowings(following)
                              : removeFollowings(following);
                          }}
                        >
                          {" "}
                          {strings.remove}
                        </button>
                      </Media>
                    </div>
                  </div>
                ))
              ) : (
                <div className="followings__empty">
                  {isGerm ? 'Keine Abonnements gefunden' : 'No followings found'}
                </div>
              )}
            </CustomScrollbars>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

export default Followings;
